<footer id="footer">
  <app-footer-center></app-footer-center>
  <div class="footer-block">
    <div class="footer-container">
      @for( item of footerData;track item;let i = $index){
      @if (isMobile()) {
      <div class="footer-accordion">
        <div class="accordion-item" [class.open]="isAccordionOpen()[i]">
          <div class="accordion-header" (click)="toggleAccordion(i)">
            <h3 class="footer-title">{{item.title}}<span class="arrow">
              @if(isAccordionOpen()[i]){
                <svg class="ml-2 align-middle" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                  <path d="M13 7L7 1L1 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            }@else{
              <svg class="ml-2 align-middle" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                <path d="M1 1L7 7L13 1" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            }
              </span>
            </h3>
          </div>
          <div class="accordion-content" [class.accordion-content-open]="isAccordionOpen()[i]">
            @for(data of item.items;track data){
            @if(data?.isDownload){
            <a  (click)="downloadpdf(data?.url)">{{data?.label}}</a>
            }@else if(data?.isRoutable){
            <a [routerLink]="data?.url">{{data?.label}}</a>
            }@else {
            <a [href]="data?.url" target="_blank">{{data?.label}}</a>
            }
            }
          </div>
        </div>
      </div>
      }
      @else {
      <div ngbDropdown>
        <div id="dropdownConfig" ngbDropdownToggle class="text-white cursor-pointer" (click)="toggleAccordion(i)" >{{item.title}} 
          <span class="arrow" >
            @if(isAccordionOpen()[i]){
              <svg class="m-bottom-negative" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M15 12.5L10 7.5L5 12.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          }@else{
            <svg  xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none" class="ml-2">
              <path d="M1 1L7 7L13 1" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          }
          </span>
        </div>
        <div ngbDropdownMenu aria-labelledby="dropdownConfig" class="acc-content">
          @for(data of item.items;track data){
          @if(data?.isDownload){
          <a  ngbDropdownItem (click)="downloadpdf(data?.url)" class="acc-content-item">{{data?.label}}</a>
          }@else if(data?.isRoutable){
          <a [routerLink]="data?.url" ngbDropdownItem class="acc-content-item">{{data?.label}}</a>
          }@else {
          <a [href]="data?.url" ngbDropdownItem target="_blank" class="acc-content-item">{{data?.label}}</a>
          }
          }
        </div>
      </div>

      }

      }
    </div>
  </div>
  <div class="footer-bottom-block">
    <div class="footer-item">
      © Copyright 2025 - All Rights Reserved
    </div>
    <div class="footer-item">
      Owned by Ministry of Skill Development and Entrepreneurship, Government of India
    </div>
    <div class="footer-item">
      <a (click)="downloadpdf('https://naps-cdn.s3.ap-south-1.amazonaws.com/Terms%20%26%20Conditions.pdf')" class="footer-box">User Terms</a>
      <span>&#9642;</span>
      <a (click)="downloadpdf('https://naps-cdn.s3.ap-south-1.amazonaws.com/Privacy%20Policy.pdf')" class="footer-box">Privacy Policy</a>
      <span>&#9642;</span>
      <a (click)="downloadpdf('https://naps-cdn.s3.ap-south-1.amazonaws.com/Disclaimer.pdf')" class="footer-box pr-0">Disclaimer</a>
    </div>
  </div>

</footer>